module.exports = __webpack_public_path__ + "img/FQSP01.8df5ea3a.svg";